<template>
  <component
    :is="component"
    :width="scale ? null : width"
    :height="scale ? null : height"
    fill="currentColor"
    class="inline-block align-baseline"
  />
</template>

<script>
import upperFirst from 'lodash.upperfirst'
import camelCase from 'lodash.camelcase'

export default {
  props: {
    svg: {
      type: String,
      required: true,
    },
    width: {
      type: [Number, String],
      default: 18,
    },
    height: {
      type: [Number, String],
      default: 18,
    },
    /**
     * Scale makes SVG scale to container, SVG needs viewbox and no h/w attributes set
     */
    scale: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    component() {
      return `SVG${upperFirst(camelCase(this.svg))}`
    }
  }
}
</script>

<docs>
The `color` style will set the icon colour. (ie: Tailwindcss class `text-red-500`)

```
<DrIcon svg="checkmark-solid" class="text-red-500" />
```

```
<DrIcon svg="checkmark-solid" />
<DrIcon svg="checkmark" />
<DrIcon svg="close-solid" />
<DrIcon svg="close" />
<DrIcon svg="delete-circle" />
<DrIcon svg="info" />
<DrIcon svg="loading" />
```

### Adding new icons
Icons are sourced from [Orion](https://orioniconlibrary.com/all-icons?style=solid) using the `solid` style.
</docs>
